import "./slidingimages.css";

export default function SlidingImages() {
  return (
    <div className="slider-scroll fade-in-reviews">
      <img src="https://i.imgur.com/Dq2P1EF.jpeg" alt="Dog images"/>
      <img src="https://i.imgur.com/VHgVYSr.jpeg" alt="Dog images"/>
      <img src="https://i.imgur.com/E6e7Xgk.jpeg" alt="Dog images"/>
      <img src="https://i.imgur.com/aesV1FA.jpeg" alt="Dog images"/>
      <img src="https://i.imgur.com/5zZoVRR.jpeg" alt="Dog images"/>
    </div>
  );
}
